export const formatDoctorName = (staffMember) =>
  [staffMember?.firstName, staffMember?.lastName].filter(Boolean).join(" ") || "-";
